import { render, staticRenderFns } from "./DetailLapProdSlit.vue?vue&type=template&id=54da2bb6&scoped=true&"
import script from "./DetailLapProdSlit.vue?vue&type=script&lang=js&"
export * from "./DetailLapProdSlit.vue?vue&type=script&lang=js&"
import style0 from "./DetailLapProdSlit.vue?vue&type=style&index=0&id=54da2bb6&lang=scss&scoped=true&"
import style1 from "./DetailLapProdSlit.vue?vue&type=style&index=1&id=54da2bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da2bb6",
  null
  
)

export default component.exports